module.exports = __webpack_public_path__ + "static/media/arkane.3e918ec3.svg";